import {useLocation} from 'react-router-dom';
import {useQuery} from "@apollo/react-hooks";
import {INTROSPECTION_QUERY} from "../routes/routeQuery";

export function useQueryString(currentSearch = useLocation().search) {
  const queryStringParams = new URLSearchParams(currentSearch);
  const buildQueryStringFromParams = (params) => {
    params.forEach(param => {
      if (!queryStringParams.has(param.key)) {
        queryStringParams.append(param.key, param.value);
      } else {
      }
    });
    return `?${queryStringParams.toString()}`;
  }

  const getQueryStringParam = (paramName, paramValue = null) => {
    if (paramValue) {
      const tags = queryStringParams.getAll(paramName); //.filter(tag => tag !== paramValue);
      if (tags) {
        return tags.filter(tagValue => tagValue === paramValue);
      }
    }
    return queryStringParams.get(paramName);
  }


  const setQueryStringParam = (paramName, paramValue) => {
    queryStringParams.set(paramName, paramValue);
  };

  const getQueryString = () => {
    return `?${queryStringParams.toString()}`;
  };

  const deleteQueryStringParam = (paramName, paramValue = null) => {
    // Logic to handle deletion of specific key-value pairs (save everything and re-apply)
    if (paramValue) {
      const tags = queryStringParams.getAll(paramName).filter(tag => tag !== paramValue);
      queryStringParams.delete(paramName);
      tags.forEach(tag => queryStringParams.append(paramName, tag));
    } else {
      queryStringParams.delete(paramName);
    }
  };

  const appendQueryStringParam = (paramName, paramValue) => {
    queryStringParams.append(paramName, paramValue);
    return `?${queryStringParams.toString()}`;
  };

  return {
    // queryStringParams,
    buildQueryStringFromParams,
    getQueryStringParam,
    getQueryString,
    setQueryStringParam,
    deleteQueryStringParam,
    appendQueryStringParam,
    // getQueryStringListingParams
  }
}